/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react';
import BioMercy from './BioMercy';
import './FadeTransition.css';

const WelcomeBiomercyLoader = () => {
  const [showMainPage, setShowMainPage] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  const isLighthouse =
    typeof navigator !== 'undefined' &&
    navigator.userAgent.includes('Chrome-Lighthouse');

  if (isLighthouse) {
    return <BioMercy />;
  }

  useEffect(() => {
    const video = document.querySelector('video');

    if (video) {
      video.playbackRate = 1.0;

      const handleVideoEnd = () => {
        setFadeOut(true); // activa animación fade-out

        setTimeout(() => {
          setShowMainPage(true); // muestra la página con transición fade-in
        }, 1000); // debe coincidir con duración de la animación
      };

      video.addEventListener('ended', handleVideoEnd);
      return () => video.removeEventListener('ended', handleVideoEnd);
    }
  }, []);

  if (showMainPage) {
    return (
      <div className="fade-in smooth-transition">
        <BioMercy />
      </div>
    );
  }

  return (
    <div className={`welcome-video-container ${fadeOut ? 'fade-out' : ''}`}>
      <video
        autoPlay
        muted
        playsInline
        preload="auto"
        className="welcome-video"
      >
        <source src="/assets/PANTALLA DE CARGA.mp4" type="video/mp4" />
      </video>
    </div>
  );
};

export default React.memo(WelcomeBiomercyLoader);
